export default "__VITE_ASSET__26518309__"